(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/views/pages/result-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/views/pages/result-page.js');

'use strict';

svs.eurojackpot.views.ResultPage = Marionette.View.extend({
  viewOptions: ['dateString'],
  dateString: undefined,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'eurojackpot',
    component: 'result'
  }],
  regions: {
    resultRegion: '#ngResultRegion'
  },
  template() {
    return svs.eurojackpot.templates.result_page();
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.eurojackpot.components.result) {
      this.showChildView('resultRegion', new svs.eurojackpot.components.result.views.Result({
        selectedDate: this.dateString
      }));
    }
  }
});

 })(window);